// front からも import されるため node:crypto は使えない (Vite がブラウザビルドで externalize する)
import { sha256 } from '@noble/hashes/sha2';
import { bytesToHex, utf8ToBytes } from '@noble/hashes/utils';
import type { Customer } from './index';

/**
 * Customer の merged metadata を表す安定したハッシュ値を返す。
 *
 * 比較目的なので、意味的に同じ metadata は必ず同じハッシュになるよう正規化する:
 * - キーは UTF-16 コードポイント順でソート
 * - 配列値（multiValued）は重複除去 + 昇順ソート
 * - null / undefined は空オブジェクト相当
 */
export const computeCustomerMetadataHash = (metadata: Customer.Metadata | undefined | null): string => {
  const source = metadata ?? {};
  const normalized: Record<string, string | string[]> = {};
  for (const key of Object.keys(source).sort()) {
    const value = source[key];
    if (Array.isArray(value)) {
      normalized[key] = [...new Set(value)].sort();
    } else {
      normalized[key] = value;
    }
  }
  return bytesToHex(sha256(utf8ToBytes(JSON.stringify(normalized))));
};
